import React from 'react';
import { AuthenticationWrapper } from '../AuthenticationWrapper';
import {
    FormContainer,
    ResetPasswordHeading,
    ResetPasswordSubheading,
    ResetPasswordIconWrapper,
    ResetPasswordHelpInfoWrapper,
    TryAgainLink,
} from '../style';
import { Icon } from '../../../Components/Icons/Icons';
import { Row, ThinText } from '../../../Layouts';
import { paths } from '../../../../Constants/paths';

export const CheckEmail = () => (
    <AuthenticationWrapper>
        <FormContainer>
            <ResetPasswordIconWrapper>
                <Icon.Box size={'52x45'}>
                    <Icon.CheckEmail />
                </Icon.Box>
            </ResetPasswordIconWrapper>
            <ResetPasswordHeading>Check your email!</ResetPasswordHeading>
            <ResetPasswordSubheading>
                You should shortly receive an email for us with a link to reset your password
            </ResetPasswordSubheading>

            <ResetPasswordHelpInfoWrapper>
                <Row marginBottom={'8px'} justify={'center'}>
                    <ThinText fontSize={16} marginRight={'8px'}>
                        Didn't receive it?
                    </ThinText>
                    <TryAgainLink to={paths.RESET_PASSWORD}>Try again</TryAgainLink>
                </Row>
                <ThinText fontSize={16}>Or email support@tona.fit</ThinText>
            </ResetPasswordHelpInfoWrapper>
        </FormContainer>
    </AuthenticationWrapper>
);



// WEBPACK FOOTER //
// ./src/UI/Containers/Authentication/ResetPassword/CheckEmail.js